function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#FFAF20",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.313 9c.632 0 1.145.504 1.145 1.125 0 .552-.405 1.012-.94 1.107l-.206.018H9.168v22.5h36.666v-3.375c0-.552.406-1.012.94-1.107l.206-.018c.563 0 1.03.398 1.128.923l.018.202v4.5c0 .552-.405 1.012-.94 1.107L46.98 36H8.021a1.14 1.14 0 0 1-1.128-.923l-.018-.202v-24.75c0-.552.405-1.012.94-1.107L8.02 9h2.291z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M53.854 0H14.896c-.633 0-1.146.504-1.146 1.125v24.75c0 .621.513 1.125 1.146 1.125h38.958c.633 0 1.146-.504 1.146-1.125V1.125C55 .504 54.487 0 53.854 0zm-1.146 2.25v22.5H16.042V2.25h36.666z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.438 18c.632 0 1.145.504 1.145 1.125 0 .552-.405 1.012-.94 1.107l-.205.018H2.292v22.5h36.666v-3.375c0-.552.406-1.012.94-1.107l.206-.018c.563 0 1.03.398 1.128.923l.018.202v4.5c0 .552-.405 1.012-.94 1.107l-.206.018H1.146a1.14 1.14 0 0 1-1.128-.923L0 43.875v-24.75c0-.552.405-1.012.94-1.107L1.146 18h2.292z"
}));

var SvgOthersTransactionsIcon = function SvgOthersTransactionsIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 45,
    style: {
      background: "transparent"
    },
    viewBox: "0 0 55 45",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOthersTransactionsIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/others_transactions_icon.b8fd7aef.svg";
export { ForwardRef as ReactComponent };